import { render, staticRenderFns } from "./CustomerAddedMe.vue?vue&type=template&id=4abc71f8&"
import script from "./CustomerAddedMe.vue?vue&type=script&lang=ts&"
export * from "./CustomerAddedMe.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerAddedMe.vue?vue&type=style&index=0&id=4abc71f8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports